
module.exports = (function() {

    return {

        datePattern: /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$|^[0-9]{4}\-[0-9]{2}$|^[0-9]{4}$/,
        urlPattern: /(http|ftp|https):\/\/[a-z0-9\-_]+(\.[a-z0-9\-_]+)+([a-z0-9\-\.,@\?^=%&;:/~\+#]*[a-z0-9\-@\?^=%&;/~\+#])?/i,
        permIdPattern: /^[0-9]+$/,
        floatPattern: /^[\+\-]*[0-9]+\.?[0-9]*?$/,
        customTypePattern: /^([A-Z]+|([A-Z]+(_[A-Z]+)+))+(\/{1}([A-Z]+|([A-Z]+(_[A-Z]+)+)))*$/,
        customTypePattern2: /^([A-Z]{2,}|([A-Z]+(_[A-Z]+)+))+(\/{1}([A-Z]{2,}|([A-Z]+(_[A-Z]+)+)))*$/,

        validEmail: (address) => {
            var re = /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i
            return re.test(address);
        },
        
        validHttpUrl: (url) => {
            var re = /^(http|https):\/\/[^ "]+$/i
            return re.test(url);
        },

        urlPatternMap: {
            'twitterNames': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?twitter\\.com/([A-Za-z0-9_]{1,15}).*'),
                'format': 'https://twitter.com/'
            },
            'legalEntityIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?(?:gleif\\.org/lei|openleis\\.com/legal_entities)/([0-9A-Z]{20})(?:[/?&].*)?'),
                'format': 'http://openleis.com/legal_entities/'
            },
            'permIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?permid\\.org/1-([0-9]+).*'),
                'format': 'https://permid.org/1-'
            },
            'ciks': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?sec\\.gov/cgi-bin/browse-edgar(?:.*)CIK=([0-9]+).*'),
                'format': 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK='
            },
            'youTubeChannelIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?youtube\\.com/channel/([^/?&]+)(?:[/?&]*)'),
                'format': 'https://www.youtube.com/channel/'
            },
            'britannicaIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)britannica\\.com/(.*)'),
                'format': 'https://www.britannica.com/'
            },
            'facebookIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?facebook\\.com/((?!pages|media|photo|permalink)[^/?&]+)(?:.*)'),
                'format': 'https://www.facebook.com/'
            },
            'freebaseIds': {
                'pattern': new RegExp('(?:https?:)?(?://)?(?:(?:www\\.)?freebase\\.com|g\\.co/kg)(/m/[^/?&]+)(?:.*)'),
                'format': 'https://g.co/kg'
            },
            'geoNameIds': {
                'pattern': new RegExp('(?:http://)?(?:www\\.)?(?:geonames\\.org/)([1-9]\\d{0,8})(?:[/?&].*)?'),
                'format': 'http://www.geonames.org/'
            },
            'quoraTopicIds': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?quora\\.com(?:/(?:topic|profile))?/([^/?&]+)(?:.*)'),
                'format': 'https://www.quora.com/topic/'
            },
            'instagramUserNames': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?instagram\\.com/((?!http)[^/?&]+)(?:.*)'),
                'format': 'https://www.instagram.com/'
            },
            'googlePlusIds': {
                'pattern': new RegExp('(?:https?://)?plus\\.google\\.com/(?:[^/?&]+/)*(\\+\\w+|[0-9]{21})(?:.*)'),
                'format': 'https://plus.google.com/'
            },
            'linkedInUrls': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?linkedin\\.com/in/(A-z0-9_-)/?'),
                'format': 'https://www.linkedin.com/in/'
            },
            'isins': {
                'pattern': new RegExp('(?:https?://)?(?:www\\.)?(?:isin\\.org/isin-preview)/\\?isin=([A-Z]{2}[A-Z\\d]+)'),
                'format': 'http://www.isin.org/isin-preview/?isin='
            }
        },

        syncIdsWithUrls: (values) => {

           // Clear out all existing id values
            for (var idField in module.exports.urlPatternMap) {
                if (idField in values) {
                    values[idField] = [];
                }
            }
        
            // For any url that matches an id equivalent, create an id field for it.
            if ('urls' in values) {
                for (var url of values['urls']) {
                    for (var idField in module.exports.urlPatternMap) {
                        var match = module.exports.urlPatternMap[idField].pattern.exec(url);
                        if (match) {
                            if (!(idField in values)) {
                                values[idField] = []
                            }
                            if (idField == 'linkedInUrls') {
                                values[idField].push(url);
                            } else {
                                values[idField].push(match[1]);
                            }
                        }
                    }
                }
            }
        },

        removeEmptyItems: (obj) => {
            Object.keys(obj).forEach(function(key) {
                let type = Object.prototype.toString.call(obj[key]);
                if (type === '[object Array]') {
                    obj[key] = obj[key].filter((item) => {
                        let itemType = Object.prototype.toString.call(item);
                        if (itemType === '[object Object]') {
                            module.exports.removeEmptyItems(item);
                            if (Object.keys(item).length == 0) {
                                return false;
                            }
                        } else {
                            if (item == null || item == '' || item.length == 0) {
                                return false;
                            } 
                        }
                        return true;
                    });
                    if (obj[key].length == 0) {
                        delete obj[key];
                    }
                } else if (type === '[object Object]') {
                    module.exports.removeEmptyItems(obj[key]);
                    if (Object.keys(obj[key]).length == 0) {
                        delete obj[key];    
                    }
                } else {
                    var val = obj[key];
                    if (type !== '[object Boolean]' && (val == null || val == '' || val.length == 0)) {
                        delete obj[key];
                    }
                }
            });
        }
    };
})();
